<template>
	<v-col class="input-ro">
		<ModalConfirm ref="modalConfirm" :msg="msgConfirm" @action="processUpgrade"></ModalConfirm>
		<div class="d-flex justify-space-between">
			<div class="text-h5 cl-primary">Upgrade Kemitraan</div>
		</div>
		<div class="pt-1 pb-2 d-flex font-size-10 grey--text">
			<v-icon small color="grey">mdi-shield-account-outline</v-icon>
			<div class="pl-2">Upgrade Kemitraan</div>
		</div>
		<div class="mt-5">
			<div v-if="!suksesUpgrade">
				<div v-if="!loading">
					<v-scroll-x-reverse-transition mode="in-out" :hide-on-leave="true">
						<div class="d-flex flex-column justify-start">
							<div class="font-size-10 cl-grey font-weight-600">
								<v-icon small color="grey">mdi-card-bulleted</v-icon>
								<span class="pl-2">Pilih Upgrade Kemitraan</span>
							</div>
							<v-radio-group class="mt-2" v-model="checkedUpgrade">
								<v-row class="ml-0">
									<v-col cols="12" sm="6" md="4" xl="3" class="pl-0 pb-0" v-for="(serialType, id) in filterSerial(Object.keys(listSerialUpgrade), myProfile.network_type)" :key="id">
										<v-card class="pa-3 elevation-0 rounded-lg hover-shadow fill-height" @click="checkUpgrade(serialType)">
											<v-row>
												<v-col cols="2" sm="2" md="2" class="my-auto">
													<v-radio on-icon="mdi-circle-slice-8" off-icon="mdi-checkbox-blank-circle-outline" class="mt-0" :value="serialType" @click="checkUpgrade(serialType)"></v-radio>
												</v-col>
												<v-col cols="8" sm="8" md="8" class="my-auto">
													<v-row>
														<v-col cols="12" md="12" class="pl-0 pl-sm-3">
															<div class="font-size-10 cl-grey">Upgrade Kemitraan</div>
															<div class="font-size-12 font-size-xs-11 cl-primary font-weight-600 text-uppercase">{{ serialType.replace('_to_', ' Ke ') }}</div>
														</v-col>
													</v-row>
												</v-col>
												<v-col cols="2" sm="2" md="2" class="pl-0 my-auto">
													<v-img src="/assets/icon/serial_upgrade.svg"></v-img>
												</v-col>
											</v-row>
										</v-card>
									</v-col>
								</v-row>
							</v-radio-group>
						</div>
					</v-scroll-x-reverse-transition>

					<v-scroll-x-reverse-transition mode="in-out" :hide-on-leave="true">
						<div v-if="checkedUpgrade">
							<div class="pt-3 font-size-10 cl-grey font-weight-500">
								<v-icon small color="grey">mdi-card-bulleted</v-icon>
								<span class="pl-2">Pilih Serial Upgrade</span>
							</div>
							
							<template v-if="listSerialChild.length > 0">
								<v-radio-group class="mt-2" v-model="checkedSerial">
									<v-row class="ml-0">
										<v-col cols="12" sm="6" md="3" xl="3" class="pl-0 pb-0" v-for="(serial, i) in listSerialChild" :key="i">
											<v-card class="pa-4 elevation-0 rounded-lg hover-shadow fill-height" :class="{'red lighten-4' : (checkSerialExpired(serial))}" :disabled="(checkSerialExpired(serial)) ? true : false" @click="checkSerial(serial.serial_member_stock_serial_id)">
												<v-row>
													<v-col cols="2" sm="2" md="2" class="my-auto">
														<v-radio on-icon="mdi-circle-slice-8" off-icon="mdi-checkbox-blank-circle-outline" class="mt-0" :value="serial.serial_member_stock_serial_id" @click="checkSerial(serial.serial_member_stock_serial_id)"></v-radio>
													</v-col>
													<v-col cols="10" sm="10" md="10">
														<v-row>
															<v-col cols="12" md="12" class="pl-0 pb-0 d-flex flex-row align-center justify-space-between">
																<div class="font-size-10 cl-grey">Serial</div>
																<div class="font-size-11 font-size-xs-11 cl-primary font-weight-600">{{ serial.serial_member_stock_serial_id }}</div>
															</v-col>
															<v-col cols="12" md="12" class="pl-0 pb-2 pt-1 d-flex flex-row align-center justify-space-between">
																<div class="font-size-10 cl-grey">Serial PV</div>
																<div class="font-size-11 cl-grey font-weight-600">{{ serial.serial_member_stock_serial_pv | toNumber }}</div>
															</v-col>
															<v-col md="12" class="pl-0 pb-0 pt-1 d-flex flex-row align-center justify-space-between">
																<div class="font-size-10 cl-grey">Pembelian</div>
																<div class="font-size-10 cl-grey font-weight-500">{{ serial.serial_member_stock_datetime | tanggal }}</div>
															</v-col>
														</v-row>
													</v-col>
												</v-row>
											</v-card>
										</v-col>
									</v-row>
								</v-radio-group>
								<div class="my-3">
									<v-row justify="center">
										<v-col cols="9" sm="3" md="2" xl="1" class="pt-0 pt-sm-3 pl-sm-0">
											<v-btn block large depressed class="bg-primary white--text rounded-lg" :loading="btnLoadingProses" :disabled="btnProses" @click="showConfirm">
												<v-icon>mdi-arrow-right-bold-circle</v-icon>
												<span class="pl-2">Proses</span>
											</v-btn>
										</v-col>
									</v-row>
								</div>
							</template>

							<template v-else>
								<v-row class="pt-3">
									<v-col cols="12" sm="12" md="12">
										<v-card class="py-3 elevation-0 hover-shadow rounded-lg">
											<NoData></NoData>
											<div class="pt-3 text-center cl-secondary">Tidak ada data serial yang dapat ditampilkan</div>
										</v-card>
									</v-col>
								</v-row>
							</template>
						</div>
					</v-scroll-x-reverse-transition>
				</div>

				<div class="mt-3" v-if="loading">
					<v-row>
						<v-col cols="12" sm="12" md="12">
							<LoadData :loading="loading"></LoadData>
						</v-col>
					</v-row>
				</div>
			</div>

			<div v-if="suksesUpgrade">
				<v-row>
					<v-col cols="12">
						<v-alert border="right" colored-border color="primary" class="mb-0 rounded-lg hover-shadow">
							<div class="d-flex">
								<v-icon color="primary">mdi-information</v-icon>
								<div class="pl-3 cl-primary font-weight-500">Selamat Anda Berhasil Melakukan Upgrade Kemitraan Anda Dengan Serial {{ responSuksesUpgrade.serial_id }}</div>
							</div>
						</v-alert>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="12" class="mt-3 mt-sm-0">
						<div class="text-center">
							<v-btn large depressed class="bg-primary white--text rounded-lg" :loading="btnLoadingBack" :disabled="btnLoadingBack" @click="backInput">
								<span class="pl-2">Kembali ke Dashboard</span>
							</v-btn>
						</div>
					</v-col>
				</v-row>
			</div>
		</div>
	</v-col>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ModalConfirm from '@/components/modals/vo/ModalConfirm';
import moment from 'moment';
// moment.locale('id');

export default {
	components: {
		ModalConfirm
	},
	data() {
		return {
			loading: false,
			page: 1,
			limit: '12',
			serial: [],
			listSerialUpgrade: [],
			listSerialChild: [],
			checkedUpgrade: '',
			checkedSerial: '',
			btnLoadingProses: false,
			btnProses: true,
			btnLoadingBack: false,
			suksesUpgrade: false,
			msgConfirm: 'Yakin ingin melakukan Upgrade Kemitraan?',
		}
	},
	computed: {
		...mapState('repeatOrder', ['responSuksesUpgrade']),
		...mapState('profile', ['myProfile']),
	},
	methods: {
		...mapActions('serial', ['getSerialAvailable', 'getSerialAvailableMitra', 'getSerialAvailablePramitra']),
		...mapActions('profile', ['getProfile']),
		...mapActions('repeatOrder', ['inputUpgrade']),

		filterSerial(data, type) {
			if (type === 'silver' || type === 'repeat_order') {
				return data
			} else {
				const serialPart = []
				data.forEach(el => {
					let parts = el.split('_to_')
					if (parts[0] === type) {
						serialPart.push(el)
					}
				});
				return serialPart
			}
		},

		getData() {
			this.loading = true
			this.getProfile()

			this.getSerialAvailableMitra().then((response) => {
				if(response) {
					let allowed = []
					if (this.myProfile.network_type === 'silver') {
						allowed = ['silver_to_gold', 'silver_to_diamond']
						const filtered = Object.keys(response.upgrade)
						.filter(key => allowed.includes(key))
						.reduce((obj, key) => {
							obj[key] = response.upgrade[key]
							return obj
						}, {})
						this.listSerialUpgrade = filtered
						this.loading = false
					}
					if (this.myProfile.network_type === 'gold') {
						allowed = ['gold_to_diamond']
						const filtered = Object.keys(response.upgrade)
						.filter(key => allowed.includes(key))
						.reduce((obj, key) => {
							obj[key] = response.upgrade[key]
							return obj
						}, {})
						this.listSerialUpgrade = filtered
						this.loading = false
					}
				}
			})
		},
		checkSerialExpired(serial) {
			if (serial) {
				const expDate = moment(serial.serial_member_stock_expired_date)
				const toDay =  moment(new Date())
				const diff = expDate.diff(toDay, 'days')
				if (diff > 0) return false
					else return true
				} else {
					return true
				}
			},
			checkUpgrade(serial) {
				this.btnProses = true
				this.checkedSerial = ''
				if (this.checkedUpgrade == serial) {
					this.checkedUpgrade = ''
					this.listSerialChild = []
				} else {
					this.checkedUpgrade = serial
					this.listSerialChild = this.listSerialUpgrade[serial]
				}
			},
			checkSerial(serial) {
				if (this.checkedSerial == serial)
					this.checkedSerial = ''
				else
					this.checkedSerial = serial
				this.enableProses()
			},
			enableProses() {
				if (this.checkedSerial)
					this.btnProses = false
				else
					this.btnProses = true
			},
			showConfirm() {
				this.$refs.modalConfirm.modalShow()
			},
			processUpgrade() {
				this.$refs.modalConfirm.loadingButton()
				let params = {
					upgrade_serial: this.checkedSerial,
					network_type: 'bin'
				}
				this.inputUpgrade(params).then(() => {
					this.checkedSerial = ''
					this.checkedUpgrade = ''
					this.listSerialChild = []
					this.$refs.modalConfirm.normalButton()
					this.$refs.modalConfirm.modalHide()
					this.suksesUpgrade = true
				}).catch(() => {
					this.$refs.modalConfirm.normalButton()
					this.$refs.modalConfirm.modalHide()
				})
			},
			backInput() {
				this.$router.push({name: 'dashboard'})
			}
		},
		created() {
			const authData = localStorage.getItem('mlmcore-vo-auth-data');
			const data = JSON.parse(authData);

			if (data.network_type === "diamond") this.$router.push({name: 'dashboard'})

			this.$store.dispatch('setPageTitle', `Upgrade Kemitraan`)
			this.getData()
		}
	};
	</script>